export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Đăng nhập thất bại, vui lòng thử lại.",
  requestFailed: "Yêu cầu thất bại, vui lòng kiểm tra kết nối internet của bạn.",
  invalidLogin: "Tên người dùng hoặc mật khẩu không hợp lệ.",
  thisFunctionExists: "Chức năng này đã tồn tại.",
  thisFunctionNotAllowDelete: "Chức năng này không được phép xóa.",
  thisFunctionNotExists: "Chức năng này không tồn tại.",
  targetFunctionIdRequired: "Cần ID chức năng mục tiêu.",
  thisPageExists: "Trang này đã tồn tại.",
  thisPageNotAllowDelete: "Trang này không được phép xóa.",
  thisRoleExists: "Vai trò này đã tồn tại.",
  thisRoleNotAllowDelete: "Vai trò này không được phép xóa.",
  targetRoleIdRequired: "Cần ID vai trò mục tiêu.",
  invalidParameter: "Tham số không hợp lệ.",
  systemError: "Hệ thống không thể xử lý yêu cầu của bạn.",
  spErrorMessage: "Lỗi thông điệp SP (Tùy thuộc vào lỗi gì).",
  actionbyRequired: "Cần người dùng hiện tại.",
  sessionTokenRequired: "Cần mã phiên.",
  functionIdRequired: "Cần ID chức năng.",
  functionNameRequired: "Cần tên chức năng.",
  newFunctionNameRequired: "Cần tên chức năng.",
  pageIdRequired: "Mã trang là bắt buộc.",
  newPageIdRequired: "Cần ID trang.",
  newPageNameRequired: "Cần tên trang.",
  targetPageIdRequired: "Cần ID trang mục tiêu.",
  passwordRequired: "Cần thiết phải có mật khẩu.",
  userNameRequired: "Cần họ tên đầy đủ.",
  passwordValidation: "Mật khẩu phải có từ 6-20 ký tự và bao gồm chữ số và chữ cái.",
  pageNumRequired: "Cần số trang.",
  pageSizeRequired: "Cần kích thước trang.",
  roleIdRequired: "Cần ID vai trò.",
  oldPasswordRequired: "Cần mật khẩu hiện tại.",
  userStatusRequired: "Cần trạng thái người dùng.",
  newRoleIdRequired: "Cần ID vai trò.",
  newRoleNameRequired: "Tên vai trò là bắt buộc.",
  startDateIsGteEndDate: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  thisRoleNotExists: "Vai trò này không tồn tại.",
  thisPageNotExists: "Trang này không tồn tại.",
  thisUserExists: "Người dùng này đã tồn tại.",
  thisUserNotExists: "Người dùng này không tồn tại.",
  thisUserBlackListed: "Tài khoản của bạn đã bị đình chỉ.",
  thisUserInactive: "Tài khoản của bạn đã bị vô hiệu hóa.",
  thisUserBlocked: "Tài khoản của bạn đã bị chặn.",
  thisUserNotActive: "Tài khoản của bạn đã bị vô hiệu hóa.",
  InvalidPageFunction: "Chức năng Trang không hợp lệ.",
  invalidUser: "Người dùng không hợp lệ!",
  invalidToken: "Phiên không hợp lệ!",
  NoUserAccessRight: "Không có quyền truy cập!",
  connection: "Lỗi Kết nối",
  profileIdRequired: "ID Hồ sơ là bắt buộc.",
  packageIdRequired: "ID Gói là bắt buộc.",
  fullNameMinThreeChar: "Họ và tên phải có ít nhất 3 ký tự.",
  accountIdMinThreeChar: "ID Tài khoản phải có ít nhất 3 ký tự.",
  searchCriteriaRequired: "Tiêu chí tìm kiếm là bắt buộc.",
  affiliateIdRequired: "ID liên kết là bắt buộc",
  minDepositRequired: "Số tiền gửi tối thiểu là bắt buộc.",
  bonusRateRequired: "Tỷ lệ thưởng là bắt buộc.",
  onlyAllowRejectDeposit: "Chỉ cho phép từ chối phiếu gửi tiền.",
  senderBankIdRequired: "Mã ngân hàng gửi là bắt buộc.",
  senderBankAccNoRequired: "Số tài khoản ngân hàng gửi là bắt buộc.",
  minFTDAmtNumOnly: "Số tiền FTD tối thiểu chỉ chấp nhận số.",
  maxFTDAmtNumOnly: "Số tiền FTD tối đa chỉ chấp nhận số.",
  crmBasicCriteriaRequired: "Mã thành viên / Số điện thoại liên hệ / Email liên hệ / Ngày đăng ký / Ngày đăng nhập cuối cùng là bắt buộc.",
  verifiedDateRangeAllowThreeMonths: "Phạm vi ngày đăng ký chỉ cho phép chọn tối đa 3 tháng.",
  lastLoginDateRangeAllowThreeMonths: "Phạm vi ngày đăng nhập cuối cùng chỉ cho phép chọn tối đa 3 tháng.",
  depositDateRangeAllowThreeMonths: "Phạm vi ngày gửi tiền chỉ cho phép chọn tối đa 3 tháng.",
  ftdDateRangeAllowThreeMonths: "Phạm vi ngày FTD chỉ cho phép chọn tối đa 3 tháng.",
  ltdDateRangeAllowThreeMonths: "Phạm vi ngày LTD chỉ cho phép chọn tối đa 3 tháng.",
  lastLoginDateEarlierThanVerifiedDate: "Ngày đăng nhập cuối cùng sớm hơn ngày đăng ký.",
  depositDateEarlierThanVerifiedDate: "Ngày gửi tiền sớm hơn ngày đăng ký.",
  ftdDateEarlierThanVerifiedDate: "Ngày FTD sớm hơn ngày đăng ký.",
  ltdDateEarlierThanVerifiedDate: "Ngày LTD sớm hơn ngày đăng ký.",
  ftdFromRequired: "Cần có ngày bắt đầu FTD.",
  ftdToRequired: "Cần có ngày kết thúc FTD.",
  ltdFromRequired: "Cần có ngày bắt đầu LTD.",
  ltdToRequired: "Cần có ngày kết thúc LTD.",
  failedToLaunchPaymentGateway: "Không thể khởi động cổng thanh toán.",
  enTitleRequired: "Cần có tiêu đề EN.",
  enBodyRequired: "Cần có nội dung EN.",
  enImageUrlRequired: "Cần có URL hình ảnh EN.",
  enImageUrlDesktopRequired: "Cần có URL hình ảnh máy tính để bàn EN.",
  enAltRequired: "Cần có alt EN.",
  enHrefRequired: "Cần có href EN.",
  resubmitTicketRequired: "Yêu cầu gửi lại vé là bắt buộc.",
  withtholdBonusAndAmountGreaterThanZero: "Giữ lại tiền thưởng và số tiền giữ lại không thể lớn hơn không cùng một lúc.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Số lần rút tối đa và số tiền rút tối đa không thể lớn hơn không cùng một lúc.",
  serverBusy: "Máy chủ đang bận. Vui lòng thử lại.",
  isRequired: "Vui lòng nhập một {fname}.",
  isMinValue: "{fname} phải có tối thiểu {fvalue}.",
  isMaxValue: "{fname} phải nhỏ hơn hoặc bằng {fvalue}.",
  isMinLength: "{fname} phải có ít nhất {fvalue} ký tự.",
  isMaxLength: "{fname} phải nhỏ hơn hoặc bằng {fvalue} ký tự.",
  isAlpha: "{fname} chỉ chấp nhận chữ cái.",
  isAlphaNum: "{fname} chỉ chấp nhận chữ cái và số.",
  isNumeric: "{fname} chỉ chấp nhận số.",
  isEmail: "{fname} chỉ chấp nhận địa chỉ email hợp lệ.",
  isIpAddress: "{fname} chỉ chấp nhận địa chỉ IPv4 hợp lệ.",
  isSameAs: "{fname} phải giống với {fname2}.",
  isUrl: "{fname} chỉ chấp nhận URL.",
  containAlphaNum: "{fname} phải có ít nhất một chữ cái và một số.",
  alphaNumWithSpace: "{fname} chỉ chấp nhận ký tự chữ và số.",
  isDecimal: "{fname} chỉ chấp nhận ký tự số.",
  isInteger: "{fname} chỉ chấp nhận số nguyên.",
  selectOption: "Vui lòng chọn một {fname}",
  notSameAs: "{fname} và {fname2} không thể giống nhau.",
  dateRangeAllowOneMonth: "Khoảng thời gian chỉ cho phép chọn tối đa 1 tháng.",
  dateRangeAllowOneYear: "Khoảng thời gian chỉ cho phép chọn tối đa 1 năm.",
  greaterThanZero: "{fname} phải lớn hơn không.",
  atLeastOneAuthority: "Phải chọn ít nhất một cơ quan.",
  BLOCK: "Tài khoản của bạn đã bị chặn.",
  SUSPEND: "Tài khoản của bạn đã bị đình chỉ.",
  CLOSE: "Tài khoản của bạn đã bị đóng.",
  RESETL: "Tài khoản của bạn đã bị đặt lại.",
  atLeastOneProvider: "Phải chọn ít nhất một nhà cung cấp.",
  failedToGetResultUrl: "Không thể lấy URL kết quả.",
  fileSizeValidation: "Quá lớn, kích thước tối đa cho phép là 1mb",
  atLeastOnePaymentOption: "Phải chọn ít nhất một tùy chọn thanh toán.",
  atLeastOnePaymentGateway: "Phải chọn ít nhất một cổng thanh toán.",
  dateRangeAllow31Days: "Khoảng thời gian chỉ cho phép chọn tối đa 31 ngày.",
  dateRangeAllow31Months: "Khoảng thời gian chỉ cho phép chọn tối đa 31 tháng.",
  dateRangeAllow31Years: "Khoảng thời gian chỉ cho phép chọn tối đa 31 năm.",
  invalidCategory: "Thể loại không hợp lệ.",
  noChanges: "Không có thay đổi.",
  permissionDenied: "Không có quyền truy cập.",
  referralCodeRequired: "Mã giới thiệu là bắt buộc.",
  providerDescRequired: "Mô tả nhà cung cấp là bắt buộc.",
  marqueeContentRequired: "Nội dung marquee là bắt buộc.",
  bonusNameRequired: "Tên thưởng là bắt buộc.",
  baseAmountRequired: "Số tiền cơ bản là bắt buộc.",
  reviewIdRequired: "Mã đánh giá là bắt buộc.",
  surveyIdRequired: "Mã khảo sát là bắt buộc.",
  questionRequired: "Câu hỏi là bắt buộc.",
  iframeIdRequired: "Mã iframe là bắt buộc.",
  bonusAmountRequired: "Số tiền thưởng là bắt buộc.",
  inboxIdRequired: "Mã hộp thư đến là bắt buộc.",
  exchangedAmountRequired: "Số tiền đã trao đổi là bắt buộc.",
  baseRateRequired: "Tỷ lệ cơ bản là bắt buộc.",
  exchangeRateRequired: "Tỷ lệ trao đổi là bắt buộc.",
  baseCurrencyRequired: "Đơn vị tiền tệ cơ bản là bắt buộc.",
  exchangeCurrencyRequired: "Cần thiết phải có loại tiền tệ trao đổi.",
  depositTypeRequired: "Cần thiết phải có loại tiền gửi.",
  nbRedepositRequired: "Cần thiết phải có số lần gửi lại.",
  bankOwnerRequired: "Cần thiết phải có chủ sở hữu ngân hàng.",
  autoSenderRequired: "Cần thiết phải có người gửi tự động.",
  isRecommendRequired: "Cần thiết phải có người giới thiệu.",
  recipientBankIdRequired: "Cần thiết phải có ID ngân hàng người nhận.",
  recipientBankAccNoRequired: "Cần thiết phải có số tài khoản ngân hàng người nhận.",
  accountBalanceRequired: "Cần thiết phải có số dư tài khoản.",
  incomingAmountThresholdRequired: "Cần thiết phải có ngưỡng số tiền đến.",
  incomingFrequencyThresholdRequired: "Cần thiết phải có ngưỡng tần suất đến.",
  outgoingAmountThresholdRequired: "Cần thiết phải có ngưỡng số tiền đi.",
  outgoingFrequencyThresholdRequired: "Cần thiết phải có ngưỡng tần suất đi.",
  bankAccTypeRequired: "Cần thiết phải có loại tài khoản ngân hàng.",
  packageRequired: "Cần thiết phải có gói dịch vụ.",
  rtpRequired: "Cần thiết phải có RTP.",
  domainIdRequired: "Cần thiết phải có ID miền.",
  buyOnBehalfRequired: "Cần thiết phải có mua thay mặt.",
  serviceProviderRequired: "Cần thiết phải có nhà cung cấp dịch vụ.",
  serverAccountRequired: "Cần thiết phải có tài khoản máy chủ.",
  nameServerRequired: "Cần thiết phải có máy chủ tên.",
  socialLinkRequired: "Cần thiết phải có liên kết xã hội.",
  newSocialPlatformRequired: "Cần thiết phải có nền tảng xã hội mới.",
  attachmentPathRequired: "Cần thiết phải có đường dẫn đính kèm.",
  depositMethodRequired: "Cần thiết phải có phương thức gửi tiền.",
  depositDateRequired: "Cần thiết phải có ngày gửi tiền.",
  refNoRequired: "Cần thiết phải có số tham chiếu.",
  withdrawalAmountRequired: "Cần thiết phải có số tiền rút.",
  targetBankAccNoRequired: "Cần thiết phải có số tài khoản ngân hàng mục tiêu.",
  targetBankIdRequired: "Cần thiết phải có ID ngân hàng mục tiêu.",
  jsonRatingRequired: "Cần thiết phải có đánh giá JSON.",
  startTimeRequired: "Cần thiết phải có thời gian bắt đầu.",
  accountIdRequired: "Cần thiết phải có ID tài khoản.",
  parentIdRequired: "Cần thiết phải có ID cha.",
  amountRequired: "Cần thiết phải có số tiền.",
  clientIpRequired: "Cần thiết phải có IP khách hàng.",
  auditByRequired: "Cần có kiểm toán bởi.",
  systemTypeRequired: "Cần có loại hệ thống.",
  currencyRequired: "Cần có loại tiền tệ.",
  ipAddressRequired: "Cần có địa chỉ IP.",
  affiliateCodeRequired: "Cần có mã liên kết.",
  contactPhoneRequired: "Cần có số điện thoại liên hệ.",
  requestTypeRequired: "Cần có loại yêu cầu.",
  securityDisabledRequired: "Cần có tắt bảo mật.",
  gameCodeRequired: "Cần có mã trò chơi.",
  seqRequired: "Cần có chuỗi.",
  minLimitRequired: "Cần có giới hạn tối thiểu.",
  maxLimitRequired: "Cần có giới hạn tối đa.",
  commSportsRequired: "Cần có hoa hồng cho thể thao.",
  commSlotsRequired: "Cần có hoa hồng cho máy đánh bạc.",
  commLivecasinoRequired: "Cần có hoa hồng cho sòng bạc trực tiếp.",
  commCockfightRequired: "Cần có hoa hồng cho đá gà.",
  commOthersRequired: "Cần có hoa hồng cho các loại khác.",
  settingValueRequired: "Cần có giá trị cài đặt.",
  vipIdRequired: "Cần có ID VIP.",
  carryOverRequired: "Cần có chuyển tiếp.",
  campaignIdRequired: "Cần có ID chiến dịch.",
  titleRequired: "Cần có tiêu đề.",
  bodyRequired: "Cần có nội dung.",
  itemOrderRequired: "Cần có thứ tự mục.",
  imageUrlRequired: "Cần có URL hình ảnh.",
  bannerIdRequired: "Cần có ID banner.",
  directionRequired: "Cần có hướng dẫn.",
  defaultOrderRequired: "Cần có thứ tự mặc định.",
  altRequired: "Cần có văn bản thay thế.",
  hrefRequired: "Cần có href.",
  targetWindowRequired: "Cần có cửa sổ mục tiêu.",
  loginRequiredRequired: "Cần có yêu cầu đăng nhập.",
  activeFromRequired: "Cần có hoạt động từ.",
  activeToRequired: "Cần có hoạt động đến.",
  bannerTypeRequired: "Cần có loại banner.",
  pageNameRequired: "Tên trang là bắt buộc.",
  remarkRequired: "Ghi chú là bắt buộc.",
  settingKeyRequired: "Khóa cài đặt là bắt buộc.",
  memberListRequired: "Danh sách thành viên là bắt buộc.",
  memberIdRequired: "Mã thành viên là bắt buộc.",
  workingMonthRequired: "Tháng làm việc là bắt buộc.",
  workingDateRequired: "Ngày làm việc là bắt buộc.",
  tacRequired: "Điều khoản và điều kiện là bắt buộc.",
  paymentModeRequired: "Phương thức thanh toán là bắt buộc.",
  newPasswordRequired: "Mật khẩu mới là bắt buộc.",
  loginIdRequired: "Mã đăng nhập là bắt buộc.",
  securityTagRequired: "Thẻ bảo mật là bắt buộc.",
  securityCodeRequired: "Mã bảo mật là bắt buộc.",
  providerCodeRequired: "Mã nhà cung cấp là bắt buộc.",
  startDateRequired: "Ngày bắt đầu là bắt buộc.",
  endDateRequired: "Ngày kết thúc là bắt buộc.",
  searchIdRequired: "Mã tìm kiếm là bắt buộc.",
  authTokenRequired: "Mã xác thực là bắt buộc.",
  newStatusRequired: "Trạng thái mới là bắt buộc.",
  actionRequired: "Hành động là bắt buộc.",
  promotionIdRequired: "Mã khuyến mãi là bắt buộc.",
  promotionNameRequired: "Tên khuyến mãi là bắt buộc.",
  rolloverRequired: "Rollover là bắt buộc.",
  criteriaRequired: "Tiêu chí là bắt buộc.",
  ticketIdRequired: "Mã vé là bắt buộc.",
  resultIdRequired: "Mã kết quả là bắt buộc.",
  bankIdRequired: "Mã ngân hàng là bắt buộc.",
  bankAccNoRequired: "Số tài khoản ngân hàng là bắt buộc.",
  bankAccHolderRequired: "Chủ tài khoản ngân hàng là bắt buộc.",
  newBankIdRequired: "Mã ngân hàng mới là bắt buộc.",
  newBankAccNoRequired: "Số tài khoản ngân hàng mới là bắt buộc.",
  newBankAccHolderRequired: "Cần có chủ tài khoản ngân hàng mới.",
  fullNameRequired: "Cần có họ tên đầy đủ.",
  depositAmountRequired: "Cần có số tiền gửi.",
  gatewayAccRequired: "Cần có tài khoản cổng.",
  labelNameRequired: "Cần có tên nhãn.",
  labelIdRequired: "Cần có ID nhãn.",
  bankTypeRequired: "Cần có loại ngân hàng.",
  amountLimitRequired: "Cần có giới hạn số tiền.",
  currencyRateRequired: "Cần có tỷ giá tiền tệ.",
  urlRequired: "Cần có URL.",
  cashRequired: "Cần có tiền mặt.",
  csRequired: "Cần có hỗ trợ khách hàng.",
  vipNameRequired: "Cần có tên VIP.",
  campaignNameRequired: "Cần có tên chiến dịch.",
  transferIdRequired: "Cần có ID chuyển khoản.",
  betTimeRequired: "Cần có thời gian đặt cược.",
  turnoverRequired: "Cần có doanh thu.",
  payoutRequired: "Cần có thanh toán.",
  winloseRequired: "Cần có thắng/thua.",
  rawMessageRequired: "Cần có tin nhắn thô.",
  authStatusRequired: "Cần có trạng thái xác thực.",
  dateRequired: "Cần có ngày.",
  betIdRequired: "Cần có ID đặt cược.",
  betStatusRequired: "Cần có trạng thái đặt cược.",
  betAmountRequired: "Cần có số tiền đặt cược.",
  isParlayRequired: "Cần có cược chéo.",
  isAddonRequired: "Cần có thêm cược.",
  withholdBonusRequired: "Cần có tiền thưởng giữ lại.",
  withholdAmountRequired: "Cần có số tiền giữ lại.",
  maxWithdrawAmountRequired: "Cần có số tiền rút tối đa.",
  betTypeRequired: "Cần có loại cược.",
  maxWithdrawMultipleRequired: "Cần có số lần rút tối đa.",
  socialPlatformRequired: "Cần có nền tảng xã hội.",
  vipProviderRebateRequired: "Cần có hoàn tiền nhà cung cấp VIP.",
  selfRebateRateRequired: "Cần có tỷ lệ hoàn tiền tự động.",
  downlineRebateRateRequired: "Cần có tỷ lệ hoàn tiền tuyến dưới.",
  tierIdRequired: "Cần có ID cấp độ.",
  rebateRateRequired: "Cần có tỷ lệ hoàn tiền.",
  paymentGatewayRequired: "Cần có cổng thanh toán.",
  rescueIdRequired: "Cần có ID cứu hộ.",
  rescueNameRequired: "Cần có tên cứu hộ.",
  rescueCycleRequired: "Cần có chu kỳ cứu hộ.",
  minLoseRequired: "Cần có mức thua tối thiểu.",
  rescueRateRequired: "Cần có tỷ lệ cứu hộ.",
  maxPayoutRequired: "Cần có mức thanh toán tối đa.",
  payoutMethodRequired: "Cần có phương thức thanh toán.",
  targetGroupRequired: "Cần có nhóm mục tiêu.",
  maintainDepositRequired: "Cần có duy trì tiền gửi.",
  maintainTurnoverRequired: "Cần có duy trì doanh thu.",
  depositOrTurnoverRequired: "Cần có tiền gửi hoặc doanh thu.",
  maintainDepositOrMaintainTurnoverRequired: "Cần có duy trì tiền gửi hoặc duy trì doanh thu.",
  vipListRequired: "Cần có danh sách VIP.",
  gameNameRequired: "Cần có tên trò chơi.",
  claimTypeRequired: "Cần có loại yêu cầu.",
  operatorIdRequired: "Cần có ID nhà điều hành.",
  maxBonusRequired: "Cần có mức thưởng tối đa.",
  endTimeRequired: "Cần có thời gian kết thúc.",
  mondayRequired: "Cần có thứ Hai.",
  tuesdayRequired: "Cần có thứ Ba.",
  wednesdayRequired: "Cần có thứ Tư.",
  thursdayRequired: "Cần có thứ Năm.",
  fridayRequired: "Cần có thứ Sáu.",
  saturdayRequired: "Cần có thứ Bảy.",
  sundayRequired: "Cần có Chủ Nhật.",
  promotionTypeRequired: "Cần có loại khuyến mãi.",
  claimLimitRequired: "Cần có giới hạn yêu cầu.",
  bonusRate1Required: "Cần có tỷ lệ thưởng 1.",
  bonusRate1To2Required: "Cần có tỷ lệ thưởng từ 1 đến 2.",
  bonusRate1To3Required: "Cần có tỷ lệ thưởng từ 1 đến 3.",
  bonusRate1To4Required: "Cần có tỷ lệ thưởng từ 1 đến 4.",
  bonusRate1To5Required: "Cần có tỷ lệ thưởng từ 1 đến 5.",
  bonusRate1To6Required: "Cần có tỷ lệ thưởng từ 1 đến 6.",
  bonusRate1To7Required: "Cần có tỷ lệ thưởng từ 1 đến 7.",
  externalIdRequired: "Cần có ID bên ngoài.",
  opsiteRequired: "Cần có Opsite.",
  opsiteContentRequired: "Cần có nội dung Opsite.",
  opsiteLanguageRequired: "Cần có ngôn ngữ Opsite.",
  opsitePaymentRequired: "Cần có thanh toán Opsite.",
  opsiteProviderRequired: "Cần có nhà cung cấp Opsite.",
  opsiteProviderGamesRequired: "Cần có trò chơi nhà cung cấp Opsite.",
  accountTypeRequired: "Cần có loại tài khoản.",
  domainNameRequired: "Cần có tên miền.",
  settledTimeRequired: "Cần có thời gian giải quyết.",
  validTurnoverRequired: "Cần có doanh thu hợp lệ.",
  resultTimeRequired: "Cần có thời gian kết quả.",
  resultStatusRequired: "Cần có trạng thái kết quả.",
  secondIdRequired: "Cần có ID thứ hai.",
  domainListRequired: "Cần có danh sách tên miền.",
  domainTypeRequired: "Cần có loại tên miền.",
  moduleRequired: "Cần có mô-đun.",
  gameIdRequired: "Cần có ID trò chơi.",
  gameDetailRequired: "Cần có chi tiết trò chơi.",
  bonusRate1To8Required: "Cần có tỷ lệ thưởng từ 1 đến 8.",
  bonusRate1To9Required: "Cần có tỷ lệ thưởng từ 1 đến 9.",
  bonusRate1To10Required: "Cần có tỷ lệ thưởng từ 1 đến 10.",
  invalidOrder: "Đơn hàng không hợp lệ.",
  bannerNotExists: "Biểu ngữ không tồn tại.",
  invalidBannerType: "Loại biểu ngữ không hợp lệ.",
  pageNameExists: "Tên trang đã tồn tại.",
  pageNotExists: "Trang không tồn tại.",
  tacIsValid: "OTP hợp lệ.",
  invalidTac: "OTP không hợp lệ.",
  tacExpired: "OTP đã hết hạn.",
  tacNotValidate: "OTP chưa được xác thực.",
  paymentModeNotExists: "Chế độ thanh toán không tồn tại.",
  paymentOptionProviderNotExists: "Tùy chọn nhà cung cấp thanh toán không tồn tại.",
  ipAddressExists: "Địa chỉ IP đã tồn tại.",
  ticketProcessed: "Vé đã được xử lý.",
  bankAccountNotExists: "Tài khoản ngân hàng không tồn tại.",
  bankAccountInactive: "Tài khoản ngân hàng không hoạt động.",
  bankMemberNotExists: "Thành viên ngân hàng không tồn tại.",
  bankMemberInactive: "Thành viên ngân hàng không hoạt động.",
  affiliateExists: "Đối tác đã tồn tại.",
  contactPhoneExists: "Số điện thoại liên hệ tồn tại.",
  affiliateFull: "Đối tác đầy.",
  uplineInactive: "Người upline không hoạt động.",
  applicationProcessed: "Đơn đăng ký đã được xử lý.",
  tacValidated: "Các điều khoản và điều kiện đã được xác nhận.",
  applicationPending: "Đơn đăng ký đang chờ xử lý.",
  favouriteGameExists: "Trò chơi yêu thích tồn tại.",
  invalidLimit: "Giới hạn không hợp lệ.",
  settingNotSet: "Cài đặt chưa được thiết lập.",
  domainNameNotExists: "Tên miền không tồn tại.",
  domainNameFull: "Tên miền đầy.",
  domainNameNotAvailable: "Tên miền không khả dụng.",
  domainNameExists: "Tên miền tồn tại.",
  subAccountNotExists: "Tài khoản phụ không tồn tại.",
  settingNotExists: "Cài đặt không tồn tại.",
  invalidContactEmail: "Email liên hệ không hợp lệ.",
  accountInactive: "Tài khoản không hoạt động.",
  campaignNotExists: "Chiến dịch không tồn tại.",
  paymentProviderNotExists: "Nhà cung cấp thanh toán không tồn tại.",
  profileInactive: "Hồ sơ không hoạt động.",
  minWithdrawalNotMet: "Số tiền rút tối thiểu không đạt yêu cầu.",
  invalidBankId: "Mã ngân hàng không hợp lệ.",
  bankAccountExists: "Tài khoản ngân hàng tồn tại.",
  bankAccountFull: "Tài khoản ngân hàng đầy.",
  bankAccHolderNotSame: "Chủ tài khoản ngân hàng không giống nhau.",
  exceedMaxWithdrawal: "Vượt quá số tiền rút tối đa.",
  exceedWithdrawalFrequency: "Vượt quá tần suất rút tiền.",
  invalidPackage: "Gói không hợp lệ.",
  promotionNotAvailable: "Khuyến mãi không khả dụng.",
  ongoingPromotion: "Khuyến mãi đang diễn ra.",
  pendingResultInGame: "Kết quả đang chờ trong trò chơi.",
  labelNameExists: "Tên nhãn tồn tại.",
  labelNotExists: "Tên nhãn không tồn tại.",
  invalidFtdMin: "Số tiền gửi lần đầu không hợp lệ.",
  invalidFtdMax: "Số tiền gửi lần đầu tối đa không hợp lệ.",
  ftdMinGtFtdMax: "Số tiền gửi lần đầu tối thiểu lớn hơn tối đa.",
  vipFull: "VIP đầy.",
  invalidRewardType: "Loại thưởng không hợp lệ.",
  vipExists: "VIP tồn tại.",
  vipNotExists: "VIP không tồn tại.",
  onlyOneMaxWithdrawSetting: "Chỉ cho phép một cài đặt rút tối đa.",
  onlyOneWithholdSetting: "Chỉ cho phép một cài đặt giữ lại.",
  campaignExists: "Chiến dịch tồn tại.",
  vipProviderNotExists: "Nhà cung cấp VIP không tồn tại.",
  turnoverTierExists: "Cấp độ doanh thu tồn tại.",
  turnoverTierFull: "Cấp độ doanh thu vượt quá cấp độ tối đa.",
  turnoverTierNotExists: "Cấp độ doanh thu không tồn tại.",
  invalidSettingValue: "Giá trị cài đặt không hợp lệ.",
  turnoverTierNotSet: "Cấp độ doanh thu chưa được thiết lập.",
  rebateProcessed: "Hoàn tiền đã được xử lý.",
  invalidActionType: "Loại hành động không hợp lệ.",
  invalidRescueCycle: "Chu kỳ cứu hộ không hợp lệ.",
  invalidPayoutMethod: "Phương thức thanh toán không hợp lệ.",
  invalidTargetGroup: "Nhóm mục tiêu không hợp lệ.",
  rescueExists: "Cứu hộ tồn tại.",
  rescueNotExists: "Cứu hộ không tồn tại.",
  walletExists: "Ví tồn tại.",
  accountExists: "Tài khoản tồn tại.",
  activeFromGtActiveTo: "Thời gian hoạt động từ lớn hơn thời gian hoạt động đến.",
  accountNotExists: "ID nhà điều hành không tồn tại.",
  invalidDeposit: "Gửi tiền không hợp lệ.",
  invalidTurnover: "Doanh thu không hợp lệ.",
  providerCodeNotExists: "Mã nhà cung cấp không tồn tại.",
  gameNameExists: "Tên trò chơi tồn tại.",
  gameNameNotExists: "Tên trò chơi không tồn tại.",
  invalidAccountType: "Loại tài khoản không hợp lệ.",
  invalidLoginIdFormat: "Định dạng ID đăng nhập không hợp lệ.",
  invalidReferralCode: "Mã giới thiệu không hợp lệ.",
  firstDepositNotMet: "Gửi tiền đầu tiên không đạt yêu cầu.",
  newbieNotMet: "Các yêu cầu cho người mới không đạt.",
  claimPromoOnlyOnce: "Chỉ yêu cầu khuyến mãi một lần.",
  promotionRequirementNotMet: "Các yêu cầu khuyến mãi không đạt.",
  withdrawalAmountLteWithholdAmount: "Số tiền rút nhỏ hơn hoặc bằng số tiền giữ lại.",
  subAccountInactive: "Tài khoản phụ không hoạt động.",
  gameNotSupported: "Trò chơi không được hỗ trợ.",
  startTimeGteEndTime: "Thời gian bắt đầu lớn hơn hoặc bằng thời gian kết thúc.",
  invalidPromotionType: "Loại khuyến mãi không hợp lệ.",
  invalidClaimType: "Loại yêu cầu không hợp lệ.",
  claimLimitExceeded10: "Giới hạn yêu cầu vượt quá 10.",
  verificationFailed: "Xác minh thất bại.",
  claimLimitReached: "Giới hạn yêu cầu đã đạt.",
  invalidPromotion: "Khuyến mãi không hợp lệ.",
  socialPlatformExists: "Nền tảng xã hội tồn tại.",
  duplicateReview: "Đánh giá trùng lặp.",
  invalidSurveyId: "ID khảo sát không hợp lệ.",
  accountNotBlock: "Tài khoản không bị chặn.",
  walletNotExists: "Ví không tồn tại.",
  socialPlatformNotExists: "Nền tảng xã hội không tồn tại.",
  socialPlatformInactive: "Nền tảng xã hội không hoạt động.",
  accountSocialExists: "Tài khoản xã hội tồn tại.",
  invalidStatus: "Trạng thái không hợp lệ.",
  samePassword: "Mật khẩu giống nhau.",
  invalidPassword: "Tên người dùng hoặc mật khẩu không hợp lệ.",
  secondaryAccountExists: "Tài khoản phụ đã tồn tại.",
  invalidSecurityCode: "Mã bảo mật không hợp lệ.",
  accountSocialNotExists: "Tài khoản xã hội không tồn tại.",
  providerInactive: "Nhà cung cấp không hoạt động.",
  gameIdExists: "ID trò chơi đã tồn tại.",
  gameIdNotExists: "ID trò chơi không tồn tại.",
  parentProviderInactive: "Nhà cung cấp chính không hoạt động.",
  betLimitNotExists: "Giới hạn cược không tồn tại.",
  min3Characters: "Tối thiểu 3 ký tự.",
  invalidBankAccType: "Loại tài khoản ngân hàng không hợp lệ.",
  senderBankNotExists: "Ngân hàng gửi không tồn tại.",
  recipientBankNotExists: "Ngân hàng nhận không tồn tại.",
  affiliateNotExists: "Đối tác không tồn tại.",
  redepositedTicket: "Vé đã được gửi lại.",
  invalidDepositType: "Loại tiền gửi không hợp lệ.",
  affiliateInactive: "Đối tác không hoạt động.",
  bonusUnavailable: "Thưởng không khả dụng.",
  pendingDeposit: "Tiền gửi đang chờ xử lý.",
  noOngoingPromotion: "Không có khuyến mãi đang diễn ra.",
  iframeNotExists: "IFrame không tồn tại.",
  gameMaintenance: "Bảo trì trò chơi.",
  labelInactive: "Nhãn không hoạt động.",
  invalidDomainType: "Loại miền không hợp lệ.",
  invalidModule: "Module không hợp lệ.",
  labelFull: "Nhãn đã đầy.",
  questionExists: "Câu hỏi tồn tại.",
  questionFull: "Câu hỏi đã đầy.",
  questionNotExists: "Câu hỏi không tồn tại.",
  reviewNotExists: "Đánh giá không tồn tại.",
  invalidDomainGroup: "Nhóm miền không hợp lệ.",
  invalidDateRange: "Khoảng thời gian không hợp lệ.",
  ipAddressNotExists: "Địa chỉ IP không tồn tại.",
  marqueeNotExists: "Marquee không tồn tại.",
  invalidAmount: "Số tiền không hợp lệ.",
  insufficientBalance: "Số dư không đủ.",
  minLimitLtParent: "Giới hạn tối thiểu nhỏ hơn cha.",
  maxLimitGtParent: "Giới hạn tối đa lớn hơn cha.",
  startDateGtEndDate: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  currencyNotExists: "Tiền tệ không tồn tại.",
  currencyExists: "Tiền tệ tồn tại.",
  noAccumulateWin: "Không có chiến thắng tích lũy.",
  invalidSession: "Phiên không hợp lệ.",
  sessionExpired: "Phiên đã hết hạn.",
  promotionExists: "Khuyến mãi tồn tại.",
  invalidCriteria: "Tiêu chí không hợp lệ.",
  promotionNotExists: "Khuyến mãi không tồn tại.",
  ticketNotExists: "Vé không tồn tại.",
  duplicateDebitRecord: "Trùng lặp bản ghi ghi nợ.",
  duplicateCreditRecord: "Trùng lặp bản ghi ghi có.",
  debitRecordNotExists: "Bản ghi ghi nợ không tồn tại.",
  minDepositNotMet: "Không đạt yêu cầu tiền gửi tối thiểu.",
  duplicateBet: "Cược trùng lặp.",
  invalidProviderCode: "Mã nhà cung cấp không hợp lệ.",
  resultExists: "Kết quả đã tồn tại.",
  unableSPProcess: "Hệ thống không thể xử lý yêu cầu của bạn.",
  authRequired: "Cần mã xác thực.",
  domainExists: "Miền đã tồn tại.",
  multiSelectOption: "Vui lòng chọn {fname}",
  invalidDomainFormat: "Định dạng miền không hợp lệ",
  noHttpHttps: "'https://' hoặc 'http://' không được phép.",
  noReservedSubdomain: "Tên miền phụ đã được đặt trước không được phép. Để sử dụng liên kết tải xuống ứng dụng.",
  operatorInactive: "Nhà điều hành không hoạt động",
  invalidAccountIdFormat: "Định dạng ID tài khoản không hợp lệ",
  contentIdRequired: "ID menu là bắt buộc",
  themeCodeRequired: "Mã chủ đề là bắt buộc",
  themeNameRequired: "Tên chủ đề là bắt buộc",
  themeColorRequired: "Màu chủ đề là bắt buộc",
  languageRequired: "Ngôn ngữ là bắt buộc",
  positionRequired: "Vị trí là bắt buộc",
  themeContentIdRequired: "ID nội dung chủ đề là bắt buộc",
  emailRequired: "Email là bắt buộc",
  themeProviderTypeRequired: "Loại nhà cung cấp chủ đề là bắt buộc",
  phoneRequired: "Điện thoại là bắt buộc",
  targetTypeRequired: "Loại mục tiêu là bắt buộc",
  packageTypeRequired: "Loại gói là bắt buộc",
  renewTermRequired: "Thời hạn gia hạn là bắt buộc",
  packagePriceRequired: "Giá gói là bắt buộc",
  packageStatusRequired: "Trạng thái gói là bắt buộc",
  sortKeyRequired: "Khóa sắp xếp là bắt buộc",
  invalidDomainStatus: "Trạng thái miền không hợp lệ",
  invalidCurrency: "Đơn vị tiền tệ không hợp lệ",
  invalidThemeCode: "Mã chủ đề không hợp lệ",
  invalidLanguage: "Ngôn ngữ không hợp lệ",
  invalidPosition: "Vị trí không hợp lệ",
  invalidThemeContent: "Nội dung chủ đề không hợp lệ",
  allParamsSameAsCurrent: "Không có thay đổi",
  invalidThemeColor: "Màu sắc chủ đề không hợp lệ",
  invalidCartStatus: "Trạng thái giỏ hàng không hợp lệ",
  invalidThemeProviderType: "Loại nhà cung cấp chủ đề không hợp lệ",
  themeProviderTypeCannotBeUse: "Loại nhà cung cấp chủ đề không thể sử dụng",
  invalidUserStatus: "Trạng thái người dùng không hợp lệ",
  packageCannotBeRemove: "Gói không thể bị xóa",
  userStatusIsAlrdSuspend: "Người dùng đã bị đình chỉ",
  userStatusIsAlrdBlocked: "Người dùng đã bị chặn",
  userStatusIsAlrdActive: "Người dùng đã hoạt động",
  invalidSortType: "Loại sắp xếp không hợp lệ",
  startDateBiggerThanEndDate: "Ngày bắt đầu lớn hơn ngày kết thúc",
  positionCannotBeUse: "Vị trí không thể sử dụng",
  funcAddContentFailed: "Thêm nội dung thất bại",
  funcDeleteContentFailed: "Xóa nội dung thất bại",
  funcUpdateContentFailed: "Cập nhật nội dung thất bại",
  funcAddThemeFailed: "Thêm chủ đề thất bại",
  funcDeleteThemeFailed: "Xóa chủ đề thất bại",
  funcUpdateThemeFailed: "Cập nhật chủ đề thất bại",
  funcAddThemeColorFailed: "Thêm màu chủ đề thất bại",
  funcDeleteThemeColorFailed: "Xóa màu chủ đề thất bại",
  funcUpdateThemeColorFailed: "Cập nhật màu chủ đề thất bại",
  funcAddLanguageFailed: "Thêm ngôn ngữ thất bại",
  funcDeleteLanguageFailed: "Xóa ngôn ngữ thất bại",
  funcUpdateLanguageFailed: "Cập nhật ngôn ngữ thất bại",
  funcAddThemeContentFailed: "Thêm nội dung chủ đề thất bại",
  funcDeleteThemeContentFailed: "Xóa nội dung chủ đề thất bại",
  funcUpdateThemeContentFailed: "Cập nhật nội dung chủ đề thất bại",
  funcAddContentPositionFailed: "Thêm vị trí nội dung thất bại",
  funcUpdateContentPositionFailed: "Cập nhật vị trí nội dung thất bại",
  funcDeleteContentPositionFailed: "Xóa vị trí nội dung thất bại",
  funcAddThemeProviderTypeFailed: "Thêm loại nhà cung cấp chủ đề thất bại",
  funcUpdateThemeProviderTypeFailed: "Cập nhật loại nhà cung cấp chủ đề thất bại",
  funcDeleteThemeProviderTypeFailed: "Xóa loại nhà cung cấp chủ đề thất bại",
  funcAddPackageFailed: "Thêm gói thất bại",
  funcUpdatePackageFailed: "Cập nhật gói thất bại",
  funcDeletePackageFailed: "Xóa gói thất bại",
  nicknameRequired: "Biệt danh là bắt buộc",
  accountStatusRequired: "Tình trạng tài khoản là bắt buộc",
  contentIdMaxLength50: "Độ dài tối đa của ID menu là 50",
  positionMaxLength10: "Độ dài tối đa của vị trí là 10",
  contentDescMaxLength200: "Độ dài tối đa của mô tả nội dung là 200",
  domainStatusRequired: "Tình trạng miền là bắt buộc",
  funcAddDomainFailed: "Thêm miền thất bại",
  funcUpdateDomainFailed: "Cập nhật miền thất bại",
  uploadFailed: "Tải lên thất bại!",
  sortKeyMaxLength50: "Độ dài tối đa của khóa sắp xếp là 50",
  invalidSortTypeFormat: "Định dạng loại sắp xếp không hợp lệ",
  invalidPackageId: "ID gói không hợp lệ",
  invalidAccountStatusFormat: "Định dạng tình trạng tài khoản không hợp lệ",
  invalidSiteStatusFormat: "Định dạng tình trạng trang không hợp lệ",
  invalidPackageStatus: "Tình trạng gói không hợp lệ",
  invalidEmailFormat: "Định dạng email không hợp lệ",
  invalidPhoneFormat: "Định dạng điện thoại không hợp lệ",
  languageLengthNotInRange: "Độ dài ngôn ngữ không nằm trong khoảng (2-5)",
  languageDescriptionMaxLength50: "Độ dài tối đa của mô tả ngôn ngữ là 50",
  remarkMaxLength500: "Độ dài tối đa của ghi chú là 500",
  themeProviderTypeMaxLength50: "Độ dài tối đa của loại nhà cung cấp chủ đề là 50",
  themeNameMaxLength50: "Độ dài tối đa của tên chủ đề là 50",
  themeColorMaxLength20: "Độ dài tối đa của màu chủ đề là 20",
  noSpace: "Không được chứa khoảng trắng",
  packageDescEnRequired: "Tên tiếng Anh là bắt buộc",
  packageDescEnMaxLength20: "Độ dài tối đa của tên tiếng Anh là 20",
  allParamsIsNull: "Tất cả các tham số đều null",
  contentCannotBeRemove: "Nội dung không thể bị xóa",
  contentDetailsRequired: "Chi tiết nội dung là bắt buộc",
  domainCannotBeUse: "Miền không thể được sử dụng",
  domainGroupMaxLength20: "Độ dài tối đa của nhóm miền là 20",
  domainGroupRequired: "Nhóm miền là bắt buộc",
  domainNameCannotUpdate: "Tên miền không thể được cập nhật",
  domainNameMaxLength400: "Độ dài tối đa của tên miền là 400",
  domainsRequired: "Các miền là bắt buộc",
  domainStatusMaxLength20: "Độ dài tối đa của tình trạng miền là 20",
  domainTypeMaxLength10: "Độ dài tối đa của loại miền là 10",
  funcAddThemeContentGroupFailed: "Thêm nhóm nội dung chủ đề thất bại",
  funcDeleteThemeContentGroupFailed: "Xóa nhóm nội dung chủ đề thất bại",
  funcOpsiteUpdateFailed: "Cập nhật Opsite thất bại",
  funcResetAccountPasswordFailed: "Đặt lại mật khẩu tài khoản thất bại",
  funcSiteLanguageUpsertFailed: "Cập nhật ngôn ngữ trang thất bại",
  funcSiteThemeContentUpsertFailed: "Cập nhật nội dung chủ đề trang thất bại",
  funcSiteThemeUpsertFailed: "Cập nhật chủ đề trang thất bại",
  funcSiteUpdateFailed: "Cập nhật trang thất bại",
  funcUpdateAccountFailed: "Cập nhật tài khoản thất bại",
  funcUpdateAccountStatusActiveFailed: "Cập nhật trạng thái tài khoản thành hoạt động thất bại",
  funcUpdateAccountStatusCompanyBlockFailed: "Cập nhật trạng thái tài khoản thành chặn công ty thất bại",
  funcUpdateAccountStatusSuspendFailed: "Cập nhật trạng thái tài khoản thành tạm ngưng thất bại",
  funcUpdateThemeContentGroupFailed: "Cập nhật nhóm nội dung chủ đề thất bại",
  invalidBoDomain: "Miền BO không hợp lệ",
  invalidOperatorIdFormat: "Định dạng ID nhà điều hành không hợp lệ",
  invalidOpsite: "Opsite không hợp lệ",
  invalidOpsiteOperator: "Nhà điều hành opsite không hợp lệ",
  invalidOpsiteVersion: "Phiên bản opsite không hợp lệ",
  invalidParentContentInGroup: "Nội dung cha trong nhóm không hợp lệ",
  invalidSite: "Trang web không hợp lệ",
  invalidSiteStatus: "Tình trạng trang web không hợp lệ",
  invalidThemeContentGroup: "Nhóm nội dung chủ đề không hợp lệ",
  languageCannotBeUse: "Ngôn ngữ không thể sử dụng",
  languagesRequired: "Các ngôn ngữ là bắt buộc",
  logo1Required: "Logo là bắt buộc",
  notSupportMultiDefault: "Không hỗ trợ đa mặc định",
  operatorIdMaxLength50: "Độ dài tối đa ID nhà điều hành là 50",
  opsiteNotMatch: "Opsite không khớp",
  packageTypeMaxLength15: "Độ dài tối đa loại gói là 15",
  parentContentIdCannotSameWithContentId: "ID nội dung cha không thể giống ID nội dung",
  phoneNumberRequired: "Số điện thoại là bắt buộc",
  siteIdRequired: "ID trang web là bắt buộc",
  siteNameMaxLength50: "Độ dài tối đa tên trang web là 50",
  siteNameRequired: "Tên trang web là bắt buộc",
  technicalError: "Lỗi kỹ thuật",
  themeCannotBeRemove: "Không thể xóa chủ đề",
  themeCodeCannotBeUse: "Mã chủ đề không thể sử dụng",
  themeCodeMaxLength20: "Độ dài tối đa của mã chủ đề là 20",
  themeColorCannotBeRemove: "Không thể xóa màu chủ đề",
  themeColorCannotBeUse: "Không thể sử dụng màu chủ đề",
  themeContentCannotBeUse: "Không thể sử dụng nội dung chủ đề",
  themeContentGroupCannotBeUse: "Không thể sử dụng nhóm nội dung chủ đề",
  themeContentGroupDescriptionMaxLength50: "Độ dài tối đa của mô tả nhóm nội dung chủ đề là 50",
  themeContentGroupMaxLength20: "Độ dài tối đa của nhóm nội dung chủ đề là 20",
  themeContentGroupRequired: "Nhóm nội dung chủ đề là bắt buộc",
  themeNameCannotBeUse: "Tên chủ đề không thể sử dụng",
  userHaventVerifyThisBefore: "Người dùng chưa xác minh điều này trước đây",
  isDefaultTrueRequired: "Ngôn ngữ phải có 1 mặc định",
  accountIdMaxLength50: "Độ dài tối đa của ID người dùng là 50",
  headBodyScriptEitherOne: "Vui lòng nhập Head Script hoặc Body Script",
  alphaOrNum: "Phải là chữ cái hoặc số",
  phoneValid: "Vui lòng nhập số điện thoại hợp lệ",
  permittedAmountRequired: "Số tiền cho phép là bắt buộc",
  ignoreRiskRequired: "Bỏ qua rủi ro là bắt buộc",
  paymentDescRequired: "Mô tả thanh toán là bắt buộc",
  gameTypeRequired: "Loại trò chơi là bắt buộc",
  statusRequired: "Tình trạng là bắt buộc",
  payoutIdRequired: "ID thanh toán là bắt buộc",
  commNotExists: "Hoa hồng không tồn tại",
  parentCommNotExists: "Hoa hồng cha không tồn tại",
  carryOverNotExists: "Carry over không tồn tại",
  hotGameExists: "Trò chơi hot đã tồn tại",
  commSportsExceededParent: "Hoa hồng cho thể thao vượt quá cha",
  commSlotsExceededParent: "Hoa hồng cho slot vượt quá cha",
  commLivecasinoExceededParent: "Hoa hồng cho casino trực tiếp vượt quá cha",
  commCockfightExceededParent: "Hoa hồng cho đá gà vượt quá cha",
  commOthersExceededParent: "Hoa hồng cho khác vượt quá cha",
  hotGameNotExists: "Trò chơi hot không tồn tại",
  noSecurityDeposit: "Không có quỹ bảo đảm",
  exchangeRateNotExists: "Tỷ giá hối đoái không tồn tại",
  insufficientSecurityDeposit: "Quỹ bảo đảm không đủ",
  duplicateDomain: "Trùng tên miền",
  contactEmailNotExists: "Email liên hệ không tồn tại",
  featuredGameNotExists: "Trò chơi nổi bật không tồn tại",
  newGameNotExists: "Trò chơi mới không tồn tại",
  popularGameNotExists: "Trò chơi phổ biến không tồn tại",
  featuredGameExists: "Trò chơi nổi bật đã tồn tại",
  newGameExists: "Trò chơi mới đã tồn tại",
  popularGameExists: "Trò chơi phổ biến đã tồn tại",
  rebateNotExists: "Khuyến mãi không tồn tại",
  riskyMember: "Thành viên rủi ro",
  ipRestricted: "IP bị hạn chế",
  notSupportedBank: "Ngân hàng không được hỗ trợ.",
  requestTooFrequent: "Yêu cầu quá thường xuyên.",
  paymentOptionNotExists: "Tùy chọn thanh toán không tồn tại.",
  earningIdRequired: "Yêu cầu ID thu nhập.",
  ptOnRequired: "Yêu cầu bật PT.",
  ptRequired: "Yêu cầu PT.",
  userIdRequired: "Cần ID người dùng.",
  businessIdRequired: "Yêu cầu ID doanh nghiệp.",
  subAccountIdRequired: "Yêu cầu ID tài khoản phụ.",
  sourceAccountIdRequired: "Yêu cầu ID tài khoản nguồn.",
  targetAccountIdRequired: "Yêu cầu ID tài khoản đích.",
  ticketTaken: "Vé đã được lấy.",
  ticketNotTaken: "Vé chưa được nhận",
  invalidPt: "PT không hợp lệ",
  topupIdRequired: "Yêu cầu ID nạp tiền",
  promotionMemberLogNotExists: "Nhật ký thành viên khuyến mãi không tồn tại",
  paymentOptionInactive: "Tùy chọn thanh toán không hoạt động",
  invalidCartStatusFormat: "Định dạng tình trạng giỏ hàng không hợp lệ",
  requestIncompleted: 'Yêu cầu chưa hoàn thành',
  unknownError: 'Đã xảy ra lỗi không xác định',
  cartIdRequired: "Yêu cầu mã giỏ hàng",
  stepNameRequired: "Yêu cầu tên bước",
  invalidCart: "Giỏ hàng không hợp lệ",
  invalidStepName: "Tên bước không hợp lệ",
  cartHaventSetupComplete: "Giỏ hàng chưa được thiết lập hoàn chỉnh",
  funcCartCreateFailed: "Không thể tạo giỏ hàng",
  funcCartUpdateFailed: "Không thể cập nhật giỏ hàng",
  funcSiteCreateFailed: "Không thể tạo trang web",
  funcCartPurchasedUpdateFailed: "Không thể cập nhật trạng thái mua hàng của giỏ",
  invalidPasswordFormat: "Định dạng mật khẩu không hợp lệ",
  currencyCodeRequired: "Yêu cầu đơn vị tiền tệ",
  funcCartLanguageUpsertFailed: "Không thể cập nhật ngôn ngữ giỏ hàng",
  invalidUserIdFormat: "Định dạng ID người dùng không hợp lệ",
  operatorPasswordRequired: "Yêu cầu mật khẩu của nhà điều hành",
  funcCartOperatorInfoUpsertFailed: "Không thể cập nhật thông tin nhà điều hành giỏ hàng",
  invalidOperatorPasswordFormat: "Định dạng mật khẩu của nhà điều hành không hợp lệ",
  operatorIdCannotBeUse: "ID nhà điều hành không thể sử dụng",
  siteNameLengthNotInRange: "Độ dài tên trang web không hợp lệ",
  userIdCannotBeUse: "ID người dùng không thể sử dụng",
  siteIdAlrdExist: "ID trang web đã tồn tại",
  operatorIdAlrdExist: "ID nhà điều hành đã tồn tại",
  externalIdAlrdExist: "ID bên ngoài đã tồn tại",
  opsiteContentAlrdExist: "Nội dung giao diện trang web đã tồn tại",
  opsiteLanguageAlrdExist: "Ngôn ngữ nội dung trang web đã tồn tại",
  boAccountAlrdExist: "Tài khoản BO đã tồn tại",
  boAccountProfileAlrdExist: "Hồ sơ tài khoản BO đã tồn tại",
  boAccountLoginAlrdExist: "Đăng nhập tài khoản BO đã tồn tại",
  funcCartThemeCodeUpsertFailed: "Không thể cập nhật chủ đề giỏ hàng",
  funcCartThemeColorUpsertFailed: "Không thể cập nhật màu giỏ hàng",
  funcOpsiteCreateFailed: "Không thể tạo nội dung trang web",
  alphabetValid: "Phải có ít nhất một chữ hoa và một chữ thường",
  numberValid: "Phải có ít nhất một số",
  symbolValid: "Phải có ít nhất một ký tự đặc biệt",
  credentialNotSet: "Thông tin xác thực chưa được thiết lập",
  validBankAccFormat: "Định dạng số tài khoản ngân hàng không hợp lệ",
  moreThan: "{fname} phải nhỏ hơn hoặc bằng {fname2}",
  lessThan: "{fname} phải lớn hơn hoặc bằng {fname2}.",
  bankAccountNotAvailable: "Tài khoản ngân hàng không có sẵn.",
  insufficientCredit: "Tín dụng không đủ",
  enableRequired: "Cần bật.",
  funcAddGameFailed: "Thêm trò chơi thất bại.",
  funcAddGameRewardByBatchFailed: "Thêm phần thưởng trò chơi theo lô thất bại.",
  funcAddGameRewardFailed: "Thêm phần thưởng trò chơi thất bại.",
  funcAddGameTemplateFailed: "Thêm mẫu trò chơi thất bại.",
  funcAddLayoutTemplateFailed: "Thêm mẫu bố cục thất bại.",
  funcAddOperatorGameFailed: "Thêm trò chơi nhà điều hành thất bại.",
  funcAddOperatorMemberWalletFailed: "Thêm ví thành viên nhà điều hành thất bại.",
  funcDeleteGameFailed: "Xóa trò chơi thất bại.",
  funcDeleteGameRewardFailed: "Xóa phần thưởng trò chơi thất bại.",
  funcDeleteGameTemplateFailed: "Xóa mẫu trò chơi thất bại.",
  funcDeleteLayoutTemplateFailed: "Xóa mẫu bố cục thất bại.",
  funcDeleteOperatorGameFailed: "Xóa trò chơi nhà điều hành thất bại.",
  funcUpdateGameFailed: "Cập nhật trò chơi thất bại.",
  funcUpdateGameRewardFailed: "Cập nhật phần thưởng trò chơi thất bại.",
  funcUpdateGameTemplateFailed: "Cập nhật mẫu trò chơi thất bại.",
  funcUpdateLayoutTemplateFailed: "Cập nhật mẫu bố cục thất bại.",
  funcUpdateOperatorGameFailed: "Cập nhật trò chơi nhà điều hành thất bại.",
  gameCannotBeRemove: "Không thể xóa trò chơi.",
  gameNameCannotBeUse: "Không thể sử dụng tên trò chơi.",
  gameNameMaxLength150: "Tên trò chơi không được dài quá 150 ký tự.",
  gameRewardCannotBeUse: "Không thể sử dụng phần thưởng trò chơi.",
  gameRewardLimitExceeded: "Đã vượt quá giới hạn phần thưởng trò chơi.",
  gameTemplateExist: "Mẫu trò chơi đã tồn tại.",
  gameTypeMaxLength20: "Loại trò chơi không được dài quá 20 ký tự.",
  invalidGame: "Trò chơi không hợp lệ.",
  invalidGameReward: "Phần thưởng trò chơi không hợp lệ.",
  invalidGameTemplate: "Mẫu trò chơi không hợp lệ.",
  invalidMemberWallet: "Ví thành viên không hợp lệ.",
  invalidOperatorGame: "Trò chơi nhà điều hành không hợp lệ.",
  invalidRewardProbability: "Xác suất phần thưởng không hợp lệ.",
  invalidTemplate: "Mẫu không hợp lệ.",
  maxGameRewardRequired: "Cần xác định phần thưởng trò chơi tối đa.",
  maxMiniGameRewardRequired: "Cần xác định phần thưởng tối đa của trò chơi nhỏ.",
  memberWalletAlrdExist: "Ví thành viên đã tồn tại.",
  operatorGameCannotBeUse: "Không thể sử dụng trò chơi nhà điều hành.",
  operatorGameIdRequired: "Cần xác định ID trò chơi nhà điều hành.",
  rewardCodeMaxLength20: "Mã phần thưởng không được dài quá 20 ký tự.",
  rewardCodeRequired: "Cần xác định mã phần thưởng.",
  rewardCurrencyMaxLength5: "Mã tiền tệ phần thưởng không được dài quá 5 ký tự.",
  rewardCurrencyRequired: "Cần xác định tiền tệ phần thưởng.",
  rewardDescriptionMaxLength100: "Mô tả phần thưởng không được dài quá 100 ký tự.",
  rewardNameMaxLength50: "Tên phần thưởng không được dài quá 50 ký tự.",
  rewardProbabilityRequired: "Cần xác định xác suất phần thưởng.",
  rewardRequired: "Cần xác định phần thưởng.",
  selectedTemplateMaxLength30: "Mẫu đã chọn không được dài quá 30 ký tự.",
  selectedTemplateRequired: "Cần chọn một mẫu.",
  success: "Thành công.",
  templateCannotBeRemove: "Không thể xóa mẫu.",
  templateCodeCannotBeUse: "Không thể sử dụng mã mẫu.",
  templateCodeMaxLength30: "Mã mẫu không được dài quá 30 ký tự.",
  templateCodeRequired: "Cần xác định mã mẫu.",
  templateNameMaxLength50: "Tên mẫu không được dài quá 50 ký tự.",
  tokenRequestRequired: "Cần xác định yêu cầu token.",
  tokenRequired: "Cần xác định token.",
  mustMoreThan: "{fname} phải lớn hơn {fvalue}",
  mustMoreThanOrEqual: "{fname} phải lớn hơn hoặc bằng {fvalue}",
  tokenInvalid: "Mã token không hợp lệ tại {key}",
  cashInvalid: "Số tiền nhập vào không hợp lệ tại {key}",
  atLeastOneRequired: "Cần ít nhất một mục",
  cash1To7Required: "Yêu cầu từ Cash 1 đến 7",
  cash1To6Required: "Yêu cầu từ Cash 1 đến 6",
  cash1To5Required: "Yêu cầu từ Cash 1 đến 5",
  cash1To4Required: "Yêu cầu từ Cash 1 đến 4",
  cash1To3Required: "Yêu cầu từ Cash 1 đến 3",
  cash1To2Required: "Yêu cầu từ Cash 1 đến 2",
  cash1Required: "Yêu cầu Cash 1",
  token1To7Required: "Yêu cầu từ Token 1 đến 7",
  token1To6Required: "Yêu cầu từ Token 1 đến 6",
  token1To5Required: "Yêu cầu từ Token 1 đến 5",
  token1To4Required: "Yêu cầu từ Token 1 đến 4",
  token1To3Required: "Yêu cầu từ Token 1 đến 3",
  token1To2Required: "Yêu cầu từ Token 1 đến 2",
  token1Required: "Yêu cầu Token 1",
  cycleRequired: "Yêu cầu chu kỳ",
  targetAmountRequired: "Yêu cầu số tiền mục tiêu",
  gamifyIdRequired: "Yêu cầu ID phần thưởng",
  gamifyMemberProcessed: "Thành viên đã được xử lý phần thưởng",
  gamifyNotExists: "Phần thưởng không tồn tại",
  gamifyInactive: "Phần thưởng không hoạt động",
  invalidCycle: "Chu kỳ không hợp lệ",
  memberIdMaxLength50: "Mã thành viên không được vượt quá 50 ký tự",
  funcAddGameWalletFreeCreditFailed: "Thêm tín dụng miễn phí vào ví trò chơi thất bại",
  funcUpdateOperatorMemberWalletBalanceFailed: "Cập nhật số dư ví thành viên của nhà điều hành thất bại",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Cập nhật số dư ví thành viên của nhà điều hành theo số tiền bị đóng băng thất bại",
  mustHaveBothAlphaNumOnly: "Chỉ sử dụng chữ cái và số, và phải có ít nhất một ký tự mỗi loại.",
  setupGameRewardBeforeEnable: "Vui lòng thiết lập phần thưởng trò chơi trước khi kích hoạt.",
  rewardProbabilityMustNotAllZero: "Xác suất phần thưởng không được bằng 0 hoàn toàn.",
  totalRewardProbabilityCannotOver100: "Tổng xác suất phần thưởng không được vượt quá 100.",
  credential1To2Required: "Cần nhập Thông tin xác thực 1 đến 2.",
  credential1To4Required: "Cần nhập Thông tin xác thực 1 đến 4.",
  newRemarkRequired: "Ghi chú là bắt buộc.",

  notSupportedWithdrawalPG: "Cổng thanh toán rút tiền không được hỗ trợ.",
};